import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.ScrollToTop = function () {
        this.$scrollToTop = null;
        this.$window = $(window);
        this.$pageWrapper = $('.pageWrapper');
        this.hideTimeout = null;

        this.init();
    };

    OndigoNS.ScrollToTop.prototype = {
        init: function () {
            var _scope = this,
                label = 'nach oben';

            this.$pageWrapper.append('<div class="scrollToTop"><div class="scrollToTopContent"><span class="upButton">' + label + '</span></div></div>');

            window.setTimeout(function () {
                _scope.$scrollToTop = $('.scrollToTop', this.$filter);
                _scope.$scrollToTop.on('click', function () {
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                    return false;
                });
            });

            this.$window.bind('scroll resize load', function () {
                if (_scope.$scrollToTop && ($(document).scrollTop() > 200)) {
                    _scope.$scrollToTop.css('position', 'fixed');
                    _scope.$scrollToTop.css('top', '');
                    _scope.$scrollToTop.css('bottom', '');
                    _scope.$scrollToTop.slideDown();
                    clearTimeout(_scope.hideTimeout);
                    _scope.hideTimeout = window.setTimeout(function () {
                        _scope.$scrollToTop.fadeOut(1000);
                    }, 3000);
                    if (_scope.$scrollToTop && (($(document).scrollTop() + $(window).height()) > ($(document).height() - $('.footer').height()))) {
                        _scope.$scrollToTop.css('position', 'absolute');
                        _scope.$scrollToTop.css('bottom', $('.footer').height());
                    }
                }
                else if (_scope.$scrollToTop) {
                    _scope.$scrollToTop.fadeOut(100);
                }
            });
        }
    };

    // plugin definition
    $.fn.scrollToTop = function () {
        return new OndigoNS.ScrollToTop();
    };
    $.fn.scrollToTop.Constructor = OndigoNS.ScrollToTop;


}(window.jQuery));

$(document).ready(function () {
    'use strict';

    $.fn.scrollToTop();
});